'use strict'

import L from 'leaflet'

export class MapPointRelaisService {
    #mapContainerId
    #map
    #markers
    #selectedPointRelais

    constructor(mapContainerId) {
        this.#mapContainerId = mapContainerId
    }

    InitMap(relais) {
        if (this.#map || !relais.length) {
            this.#ForceFullMapDisplay()
            this.BuildMarkers(relais)
            return
        }

        const closestPointRelais = relais[0]

        this.#map = L.map(this.#mapContainerId, {
            zoomControl: false
        }).setView(
            [closestPointRelais.Latitude, closestPointRelais.Longitude],
            14
        )

        this.BuildMarkers(relais)

        this.#AddMapLayer()

        this.#AddCustomIcons()

        this.#AddMapEventHandlers()
    }

    #AddMapLayer() {
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution:
                '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.#map)
    }

    #AddCustomIcons() {
        // Zoom
        L.control
            .zoom({
                position: 'topright',
                zoomInText:
                    '<img src="https://media.modz.fr/pictures/site/images/element_graphique/map/zoom_in.svg"/>',
                zoomOutText:
                    '<img src="https://media.modz.fr/pictures/site/images/element_graphique/map/zoom_out.svg"/>'
            })
            .addTo(this.#map)

        // Localisation
        L.Control.Location = L.Control.extend({
            onAdd: function () {
                const div = L.DomUtil.create('div')

                div.id = 'location-icon'
                div.style.height = '32px'
                div.style.width = '32px'
                div.style.backgroundColor = '#fff'
                div.style.cursor = 'pointer'
                div.style.borderRadius = '2px'
                div.style.display = 'flex'
                div.style.justifyContent = 'center'
                div.style.alignItems = 'center'

                const img = L.DomUtil.create('img')

                img.src =
                    'https://media.modz.fr/pictures/site/images/element_graphique/map/location.svg'
                img.style.height = '14px'
                img.style.width = '14px'

                div.appendChild(img)

                return div
            }
        })

        L.control.location = function (opts) {
            return new L.Control.Location(opts)
        }

        L.control.location({ position: 'topright' }).addTo(this.#map)
    }

    #AddMapEventHandlers() {
        this.#map.whenReady(() => {
            this.#ForceFullMapDisplay()
        })

        this.#map.on('move', (e) => {
            if (!e.originalEvent) {
                return
            }

            document.dispatchEvent(new Event('mpr-move'))
        })

        this.#map.on('zoomanim', (e) => {
            document.dispatchEvent(new Event('mpr-move'))
        })

        $('#location-icon').on('click', () => {
            $('#location-icon').css('background-color', '#fff')
            document.dispatchEvent(new Event('mpr-geolocation'))
        })
    }

    #ForceFullMapDisplay() {
        window.dispatchEvent(new Event('resize'))
    }

    BuildMarkers(relais) {
        this.#markers = L.layerGroup()

        const selectedRelais = relais.find((x) => x.IsSelected)

        relais.forEach((x, idx) => {
            const marker = L.marker([x.Latitude, x.Longitude], {
                icon: this.#GetPointRelaisIcon(x),
                Identifiant: x.Identifiant,
                MoyenLivraison: x.MoyenLivraison,
                IsLocker: x.IsLocker
            }).on('click', (e) => this.#EmitSelectionEvent(e, x))

            this.#markers.addLayer(marker)

            if (
                (selectedRelais &&
                    x.Identifiant === selectedRelais.Identifiant) ||
                (!selectedRelais && idx === 0)
            ) {
                this.#selectedPointRelais = marker
                this.CenterPointRelais(x)
            }
        })

        this.#map.addLayer(this.#markers)
    }

    ClearMarkers() {
        if (!this.#markers) {
            return
        }

        this.#markers.clearLayers()
    }

    #GetPointRelaisIcon(x) {
        const PointRelaisIcon = L.Icon.extend({
            options: {
                iconSize: x.IsSelected ? [50, 125] : [38, 95]
            }
        })

        let icon = ''
        switch (x.MoyenLivraison) {
            case 9:
                icon = x.IsLocker
                    ? 'marker_relaiscolis_locker'
                    : 'marker_relaiscolis'

                icon = x.IsSelected ? icon + '_selected.svg' : icon + '.svg'

                return new PointRelaisIcon({
                    iconUrl: `https://media.modz.fr/pictures/site/images/element_graphique/map/${icon}`
                })
            case 8:
            case 14:
                icon = x.IsLocker
                    ? 'marker_chronopost_locker'
                    : 'marker_chronopost'

                icon = x.IsSelected ? icon + '_selected.svg' : icon + '.svg'

                return new PointRelaisIcon({
                    iconUrl: `https://media.modz.fr/pictures/site/images/element_graphique/map/${icon}`
                })
            default:
                return new PointRelaisIcon({ iconUrl: '' })
        }
    }

    #EmitSelectionEvent(event, pointRelais) {
        this.#UpdateSelectedPointRelaisIcon()

        this.#selectedPointRelais = event.target

        this.#selectedPointRelais.setIcon(
            this.#GetPointRelaisIcon({ ...pointRelais, IsSelected: true })
        )

        this.#selectedPointRelais.setZIndexOffset(999)

        document.dispatchEvent(
            new CustomEvent('mpr-selection', {
                detail: {
                    Identifiant: pointRelais.Identifiant
                }
            })
        )
    }

    #UpdateSelectedPointRelaisIcon() {
        if (!this.#selectedPointRelais) {
            return
        }

        this.#selectedPointRelais.setZIndexOffset(-999)
        this.#selectedPointRelais.setIcon(
            this.#GetPointRelaisIcon({
                MoyenLivraison:
                    this.#selectedPointRelais.options.MoyenLivraison,
                IsLocker: this.#selectedPointRelais.options.IsLocker,
                IsSelected: false
            })
        )
    }

    CenterPointRelais(pointRelais) {
        this.#UpdateSelectedPointRelaisIcon()

        this.#selectedPointRelais = this.#markers
            .getLayers()
            .find((x) => x.options.Identifiant === pointRelais.Identifiant)

        this.#markers.eachLayer((x) => {
            if (x.options.Identifiant !== pointRelais.Identifiant) {
                return
            }

            x.setZIndexOffset(999)
            x.setIcon(
                this.#GetPointRelaisIcon({
                    ...pointRelais,
                    IsSelected: true
                })
            )
        })

        this.#map.panTo(
            new L.LatLng(pointRelais.Latitude, pointRelais.Longitude)
        )
    }

    GetMapCenterCoordinates() {
        const { lat, lng } = this.#map.getCenter()

        return {
            Latitude: lat,
            Longitude: lng
        }
    }

    HandleGeolocationDisabled() {
        $('#location-icon').css('background-color', '#dadada')
    }
}
